import '@fontsource-variable/dm-sans'
import '@fontsource-variable/manrope'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './app/App'
import { ProveedorAuth } from '@eg/compartido'
import { ProveedorAvisos, ProveedorMovimiento } from '@eg/efectos'
import { supabase } from './lib/supabase'
import './index.css'

const consultas = new QueryClient({ defaultOptions: { queries: { staleTime: 60_000, retry: 1 } } })

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={consultas}>
      <ProveedorAuth cliente={supabase}>
        <ProveedorMovimiento>
          <ProveedorAvisos>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ProveedorAvisos>
        </ProveedorMovimiento>
      </ProveedorAuth>
    </QueryClientProvider>
  </StrictMode>,
)
